import React, { useState, useEffect, useCallback } from "react";
import {
  TextField,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  TextareaAutosize,
  Autocomplete,
  FormControl,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../../redux/loader/actions";
import { showSnackbar } from "../../../redux/snackbar/actions";
import { encryptAES, decryptAES } from "../../../utils";

const useStyles = makeStyles({
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
  dialogTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  closeButton: {
    marginLeft: "auto",
  },
});

const VendorCreation = ({ open, onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      remarks: "",
      transfercount: "",
    },
    validationSchema: Yup.object({
      remarks: Yup.string().required("remarks is required"),
      transfercount: Yup.string().required("Transfer Count number is required"),
    }),
    // onSubmit: handleSubmit,
  });
  const purchaseOptions = ["Transactional SMS", "Transactional Whatsapp"];
  const communicationOptions = ["Entity1", "Entity2"];

  const [validityType, setValidityType] = useState("");

  const handleValidityChange = (event) => {
    setValidityType(event.target.value);
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle disableTypography className={classes.dialogTitleContainer}>
        Add Transfer
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          className={classes.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box textAlign="right">
          <Typography variant="subtitle2">
            Available Sourcing Count: 200
          </Typography>
        </Box>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={12} md={4}>
            <Autocomplete
              fullWidth
              multiple
              options={communicationOptions}
              value={formik.values.frequency}
              onChange={(e, value) => formik.setFieldValue("frequency", value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Entity Name"
                  name="frequency"
                  placeholder="Select Entity Name"
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.frequency && Boolean(formik.errors.frequency)
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Autocomplete
              fullWidth
              multiple
              options={communicationOptions}
              value={formik.values.frequency}
              onChange={(e, value) => formik.setFieldValue("frequency", value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Communication Type"
                  name="frequency"
                  placeholder="Select Communication Type"
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.frequency && Boolean(formik.errors.frequency)
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <TextField
              name="transfercount"
              label="Transfer Count "
              variant="outlined"
              fullWidth
              value={formik.values.transfercount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.transfercount &&
                Boolean(formik.errors.transfercount)
              }
              helperText={
                formik.touched.transfercount && formik.errors.transfercount
              }
            />
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <TextField
              label="Remarks"
              name="remarks"
              multiline
              minRows={1}
              maxRows={4}
              fullWidth
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.remarks && Boolean(formik.errors.remarks)}
              helperText={formik.touched.remarks && formik.errors.remarks}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box m={2}>
          <Button
            variant="contained"
            color="primary"
            className={classes.animatedButton}
            onClick={formik.handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default VendorCreation;
